import React from "react";

export default function TopScrollingText() {
    return (
        <div className="marquee-wrapper">
            <div class="marquee">
                <div class="marquee-track">
                    <span>Minimum 2 pieces (You can mix any Pattern / Models) for an order, 360° opening video must for any sort of complaint.</span>
                    <span>Minimum 2 pieces (You can mix any Pattern / Models) for an order, 360° opening video must for any sort of complaint.</span>
                    <span>Minimum 2 pieces (You can mix any Pattern / Models) for an order, 360° opening video must for any sort of complaint.</span>
                </div>
            </div>
        </div>
    );
}